import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, STORAGE_KEY, SUPPORTED_LANGUAGES } from './languages.js';

import enIN from './locales/en-IN.json';
import hi from './locales/hi.json';
import ta from './locales/ta.json';
import te from './locales/te.json';
import kn from './locales/kn.json';
import ml from './locales/ml.json';
import gu from './locales/gu.json';
import mr from './locales/mr.json';
import pa from './locales/pa.json';

const saved = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
const supportedLngs = SUPPORTED_LANGUAGES.map((lang) => lang.code);
const initialLanguage = saved && supportedLngs.includes(saved) ? saved : DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    'en-IN': { translation: enIN },
    hi: { translation: hi },
    ta: { translation: ta },
    te: { translation: te },
    kn: { translation: kn },
    ml: { translation: ml },
    gu: { translation: gu },
    mr: { translation: mr },
    pa: { translation: pa },
  },
  lng: initialLanguage,
  supportedLngs,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
